<template lang="pug">
.main  
  base-header(ref="jello").pb-1
    b-row.py-4(aling-v='center')
      b-col(cols='7' lg='6')
        h6.h2.text-white.d-inline-block.mb-0 Settings

  b-container(fluid, v-if="config")
    b-row.mt-5
      b-col(cols="10")
       
        JsonEditor(
          :options="{confirmText: 'confirm', cancelText: 'cancel'}",

          :objData="config.config" ,
          v-model="config.config").w-100



          
             
          

</template>
<script>
  // Charts
  import Vue from 'vue';



  function randomScalingFactor() {
    return Math.round(Math.random() * 100);
  }

  export default {
    components: {
 
    },
    data() {
      return {
        options: null,
        config: null,
        selected: null,
        
      } 
    },
    methods: {

      add(selected) {
        let new_item = {};

        new_item.uuid = this.$_.uniqueId()
        new_item.check = selected;
        new_item.params = {};
        this.config.pipeline.push(new_item)
      },

      save_config(ic) {
        this.axios.put(this.base_url + '/configuration/instance', ic).then((response) => {
          this.options = response.data;
          this.$bvToast.toast("Pipeline saved", {
            title: "Pipeline saved",
            variant: 'primary',
            autoHideDelay: 1000,
          });
        });
      },

      moveUp(uuid) {
        let index = this.config.pipeline.findIndex(x => x.uuid === uuid);
        if (index > 0) {
          this.config.pipeline.splice(index - 1, 0, this.config.pipeline.splice(index, 1)[0]);
        }
      },

      moveDown(uuid) {
        let index = this.config.pipeline.findIndex(x => x.uuid === uuid);
        if (index < this.config.pipeline.length - 1) {
          this.config.pipeline.splice(index + 1, 0, this.config.pipeline.splice(index, 1)[0]);
        }
      }

    

      
    },
    watch: {
     
    },

    async mounted() {
    
     

      this.axios.get(this.base_url + '/configuration/instance').then((response) => {
        
        this.config = response.data;
      });

    }
  };
</script>
<style></style>
